import { AccountTabContent } from '@components/password-form';
import { StripeIntegration } from './stripe-integration';
import { ZapierIntegration } from './zapier-integration';
import { ZoomIntegration } from './zoom-integration';
import { rpx } from 'client/lib/rpx-client';
import { useAsyncData } from 'client/lib/hooks';
import { DefaultSpinner } from '@components/spinner';
import { CollectAddressToggle } from './collect-address-toggle';
import { useConfiguration } from 'client/lib/auth';

export function IntegrationsTab() {
  const { tenant } = useConfiguration();
  const loader = useAsyncData(() => rpx.accounts.getIntegrations(), []);

  if (loader.isLoading || !loader.data) {
    return <DefaultSpinner />;
  }

  const { stripeAcct, collectAddress } = loader.data;

  return (
    <AccountTabContent title="Integrations">
      <div class="flex flex-col border rounded-lg divide-y">
        {!tenant.isCore && (
          <>
            <StripeIntegration stripeAcct={stripeAcct} />
            {stripeAcct && <CollectAddressToggle collectAddress={collectAddress} />}
            <ZapierIntegration />
          </>
        )}
        <ZoomIntegration />
      </div>
    </AccountTabContent>
  );
}
